<template>
  <div class="text__center one-request--change tile">
    <p class="text__bold">Remove Service</p>
    <ul class="change-list text__left">
      <li class="change-list--item">
        Remove a service from
        <strong>this</strong> request if it does not apply
      </li>
      <li class="change-list--item">
        To mark this service inactive for future requests visit
        <router-link to="/services">here</router-link>
      </li>
    </ul>
    <p v-if="getActiveServices.length === 0">No Active Services</p>
    <div v-else class="change-form flex__center">
      <select name="removal" v-model="service">
        <option
          v-for="service in getActiveServices"
          :key="service._id"
          :value="service"
        >{{ service.name }}</option>
      </select>
      <button class="btn btn__small btn__red" @click="removeService">Remove</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["active", "type"],
  data() {
    return {
      service: null
    };
  },
  computed: {
    getActiveServices() {
      return this.active.services.filter(service => {
        return service.active;
      });
    }
  },
  methods: {
    async removeService() {
      if (!this.service) {
        return this.flash("Remove error: A service must be selected", "error");
      }
      const updatedService = {
        ...this.service,
        active: false
      };
      await this.$store.dispatch(
        `${this.type.namespace}/startUpdateRequest`,
        updatedService
      );
      this.service = null;
    }
  }
};
</script>

<style scoped>
</style>